import React, { Component, Fragment } from 'react';

import { restRequest } from '../../../../Helpers/RequestHelper';
import { NewItemIcon } from '../../../../Assets/Navigation/NavigationIcons';
import HeaderWrapper from '../../../../Components/HeaderWrapper/HeaderWrapper';
import Box from '../../../../Components/Layout/Box';
import { ActionMenu } from '../../../../Components/CheckedMenu/CheckedMenu';
import ListTableImageColumn from '../../../../Components/ListTable/ListTableImageColumn';
import Table from '../../../../Components/Table/Table';
import { MdAdd, MdClose, MdRemove } from '../../../../Common/Icons';
import Loader from '../../../../Components/Loader/Loader';
import NotFound from '../../../../Components/NotFound/NotFound';
import {
  setValueInLS,
  getObjFromLS,
  setObjInLS,
} from '../../../../Helpers/LocalStorage';
import { checkError } from '../../../../Helpers/AuthHelper';
import './itemGroupDetail.css';
import ItemDetailsImages from '../../ItemDetails/Info/ItemDetailsImages';
import ImportIcon from '../../../../Assets/General/ImportIcon';
import AddRetrunReceive from '../../../../Assets/General/AddRetrunReceive';
import CustomModal from '../../../../Components/CustomModal/CustomModal';
import OpenStockTable from './OpenStockTable';
import { TempItemMappedModal } from '../../../../Common';
import AccessDenied from '../../../../Components/AccessDenied/AccessDenied';
import { HeaderMenus, Menu, MenuData, Quantity } from '../../../../Components';
import { withTranslation } from 'react-i18next';
import { t } from 'i18next';
import { History } from '../../../../Assets/General';
import { Field } from '../../../../Components/Form';
import { getCurrentMenu } from '../../../../Helpers';

class RawItemDetails extends Component {
  id = this.props.id
    ? this.props.id
    : this.props.idFromHeaderWrapper
      ? this.props.idFromHeaderWrapper
      : this.props.match.params.id;
  state = {
    itemGroup: {},
    items: [],
    // itemGroupOpenStock: {},
    currency: {},
    loading: true,
    notFound: false,
    detailsNo: '',
    showOpeningStock: false,
    showConfirmationModal: false,
    currentMenu: getCurrentMenu(window.location.search),
    showAdjustquantityModal: false,
    confirmationModalDataItem: {},
    confirmationModalLoading: false,
    confirmationModalWoocomList: [],
    confirmationModalBtnLoader: false,
    viewAssociationTable: false
  };

  componentDidMount() {
    if (!this.props.inModal) {
      document.title = 'Raw Item Details';
    }
    this.fetchData();
    //await this.fetchOpenStockData()
  }

  fetchData() {
    this.setState({ loading: true });
    restRequest('get', `rawitems/${this.id}`)
      .then((res) => {
        //console.log(res, "res>>>>>>>>");
        this.setState({
          itemGroup: res,
          items: res.items,
          // itemGroupOpenStock: res,
          detailsNo: res?.name,
          // currency: res.currency,
          loading: false,
          viewAssociationTable: res.items.length > 0,
        });
        // this.fetchOpenStockData();
        let dataFromLS = getObjFromLS('module');
        //console.log(dataFromLS, "dataFromLS")
        setObjInLS('module', {
          ...dataFromLS,
          presistDetailPage: true,
        });
      })
      .catch((err) => {
        //console.log('err1', err)
        checkError(err);
        this.setState({ notFound: true, loading: false });
      });
  }

  renderActionMenu() {
    //console.log("calk")
    const [hasCreatePermission, hasEditPermission, hasDeletePermission] =
      this.hasPermission('itemGroups', 'All');
    const { is_active } = this.state.itemGroup;
    //console.log(hasCreatePermission, hasEditPermission, hasDeletePermission, "permissions>>>>>>");
    const menusList = [
      hasCreatePermission && {
        type: 'button',
        className: 'button--primary float-left mr-3',
        handleClick: () => this.setState({ showAdjustquantityModal: true }),

        label: "Adjust Quantity",
        icon: 'new',
      },
      {
        type: 'link',
        icon: 'edit',
        enable: hasEditPermission || false,
        to: `/raw-items/edit/${this.id}`,
        tooTip: this.props.t('Items.edit'),
        mobileLable: this.props.t('Items.edit'),
        isMobile: true,
      },
      {
        type: 'button',
        icon: 'delete',
        tooTip: this.props.t('Items.delete'),
        mobileLable: this.props.t('Items.delete'),
        isMobile: true,
        handleClick: () =>
          this.openDeleteModal(
            this.id,
            this.props.forceRedirect,
            this.props.forceRedirectFlag
          ),
        enable: hasDeletePermission || false,
      },
      {
        type: 'button',
        icon: is_active ? 'inactive' : 'active',
        tooTip: is_active
          ? this.props.t('Items.inactive')
          : this.props.t('Items.active'),
        isMobile: true,
        mobileLable: is_active
          ? this.props.t('Items.inactive')
          : this.props.t('Items.active'),
        enable: hasEditPermission || false,
        handleClick: () =>
          this.toggleActive(this.id, !is_active ? 'active' : 'inactive'),
      },
      hasCreatePermission && {
        type: 'button',
        className: 'button--primary float-left mr-3',
        handleClick: () => this.props.history.push(`/raw-items/add`),
        label: this.props.t('Items.new'),
        icon: 'new',
      },
    ];
    return (
      <ActionMenu>
        <HeaderMenus menusList={menusList} loading={this.state.loading} />
      </ActionMenu>
    );
  }

  renderItemGroupDetailsInfo() {
    const { itemGroup } = this.state;
    // console.log('itemGroup', itemGroup);
    const {
      unit,
      description,
      physical_stock,
      accounting_stock,
      stocks
      ,
      remaining_stock,
      opening_stock,
      re_order_level,
      // total_items,
      // item_attribute,
      // manufacturer,
      // brand,
    } = itemGroup;
    return (
      <div>
        <div className="section-details--info w-80">

          {/* <hr className="bottom_line" /> */}

          <div className="field-row">
            <div className="section-details--info-title semi-bold heading_font">
              {this.props.t('Items.unit_name')}
            </div>
            <div className="semi-bold">{unit}</div>
          </div>
          <hr className="bottom_line" />


          <div className="section-details--info-title semi-bold heading_font">
            {this.props.t('Items.description')}
          </div>
          <div>
            <p className="desc-set">{description}</p>
          </div>
        </div>
        <div >

          {/* <hr className="bottom_line" /> */}




          <div className="stock_row stock_mob-row">
            <div className="float-left w-33 pr-10">
              <div className="stock_row_inner float-left w-100 background_custom p-10 height_custom">
                <span className="upper_text">{t('Items.accounting_stock')}</span>
                <hr />
                <div>
                  <div className="stockfields">
                    <span>{t('Items.stock_on_hand')}</span>
                    <span> {stocks?.accounting_stock.stock_on_hand}</span>
                  </div>
                  <hr />
                  <div className="stockfields">
                    <span>{t('Items.committed_stock')}</span>
                    <span> {stocks?.accounting_stock.committed_stock}</span>
                  </div>
                  <hr />
                  <div className="stockfields">
                    <span>{t('Items.available_for_sale')}</span>
                    <span> {stocks?.accounting_stock.available_sale_stock}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="float-left w-33 pr-10 ">
              <div className="stock_row_inner float-left w-100 background_custom p-10 height_custom">
                <span className="upper_text">{t('Items.physical_stock')}</span>
                <hr />
                <div>
                  <div className="stockfields">
                    <span>{t('Items.stock_on_hand')}</span>
                    <span> {stocks?.physical_stock.stock_on_hand}</span>
                  </div>
                  <hr />
                  <div className="stockfields">
                    <span>{t('Items.committed_stock')}</span>
                    <span> {stocks?.physical_stock.committed_stock}</span>
                  </div>
                  <hr />
                  <div className="stockfields">
                    <span>{t('Items.available_for_sale')}</span>
                    <span> {stocks?.physical_stock.available_sale_stock}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="float-left w-33 pr-10">
              <div className="stock_row_inner float-left w-100 background_custom p-10 height_custom">
                <div className="stock_information">
                  {/* <div className="float-left w-100">
          <span className="float-left">{t('Items.inventory_account')}</span>
          <span className="float-right">
            {inventoryAccount?.title === 'Inventory Asset'
              ? t('Items.inventory_asset')
              : inventoryAccount?.title}
          </span>
        </div> */}
                  <div className="float-left w-100">
                    <span className="float-left">{t('Items.opening_stock')}</span>
                    <span className="float-right">{stocks?.opening_stock}</span>
                  </div>
                  {/* <div className="float-left w-100 d-flex space-between">
          <span className="float-left">{t('Items.opening_stock_valuee')}</span>
          <span
            className="float-right"
            style={{ width: '40%', textAlign: 'right', wordBreak: 'break-word' }}
          >
            {`${symbol}${OpeningStockValue.toFixed(2)}`}
          </span>
        </div> */}
                  <div className="float-left w-100">
                    <span className="float-left">{t('Items.reorder_value')}</span>
                    <span className="float-right">{re_order_level}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>


    );
  }
  handleTabChange(tab) {
    this.setState({ currentMenu: tab });
  }
  menus() {
    return [
      {
        id: 'history',
        label: this.props.t('bill.history'),
        billId: this.id,
        url: `rawitems/${this.id}/activity`,
        icon: () => <History />,
        onClick: (flag = true) => {
          if (flag === false) this.handleTabChange('');
          else this.handleTabChange('history');
        },
        renderContent: this.renderMenuForHistory,
      },
      // {
      //   id: 'payments',
      //   label: this.props.t('bill.payments'),
      //   billId: this.id,
      //   url: `bills/${this.id}/activity-log`,
      //   history: this.props.history,
      //   forceRedirectFlag: this.props.forceRedirectFlag,
      //   handleLoad: this.handleLoad,
      //   icon: () => <RecordPaymentIcon />,
      //   billAmount: this.state.billInfo.total,
      //   billStatus: this.state.billInfo.status,
      //   updateStatusOnPaymentChange: this.updateStatusOnPaymentChange,
      //   currency: this.state.currency,
      //   handleToast: this.props.handleToast,
      //   hasPermissionCustom: this.hasPermissionCustom,
      //   hasViewPermission: this.hasViewPermission('payment'),
      //   inModal: this.props.inModal,
      //   onClick: (flag = true) => {
      //     if (flag === false) this.handleTabChange('');
      //     else this.handleTabChange('payments');
      //   },
      //   renderContent: this.renderMenuForBillPayment,
      // },
    ];
  }
  renderMenuForHistory() {
    return <MenuData name="History" invoiceId={this.id} url={this.url} />;
  }
  renderLayoutView() {
    const { itemGroup } = this.state;

    const { images } = itemGroup;
    return (
      <Fragment>
        <div className="float-left w-100 item_group_summary_update position-relative raw_item_image_details">

          <ItemDetailsImages images={images} className="raw_item_image" inModal={true} />
          {this.renderItemGroupDetailsInfo()}
        </div>
      </Fragment>
    );
  }

  tempModalhandler = (itemData) => {
    const { storeType = '', store_id = null } = itemData;
    const url =
      storeType === 'shopify'
        ? `shopify/items/ims/${store_id}`
        : `woocom/items/ims/${store_id}`;

    this.setState(
      {
        confirmationModalLoading: true,
        showConfirmationModal: true,
        confirmationModalDataItem: itemData,
      },
      () => {
        restRequest('get', url)
          .then((res) => {
            if (res?.ims_items?.length) {
              let options = res?.ims_items.map((option, i) => {
                const stock_preference = res.stock_preference;
                let ims_stock;
                if (stock_preference === 'physical_stock') {
                  ims_stock = option.physical_stock;
                } else {
                  ims_stock = option.accounting_stock;
                }
                return {
                  ...option,
                  label: option.name,
                  value: option.id,
                  ims_stock: ims_stock,
                };
              });
              this.setState({ confirmationModalWoocomList: options }, () => {
                this.setState({ confirmationModalLoading: false });
              });
            } else {
              // this.props.handleToast('Ims items not found', 'error');
              // this.setState({ showConfirmationModal: false });
              this.setState({ confirmationModalLoading: false });
            }
          })
          .catch((error) => {
            this.props.handleToast(error, 'error');
            this.setState({ showConfirmationModal: false });
          });
      }
    );
  };


  prepareItemsData(items, currency) {
    let itemArr = Array.isArray(items) ? items : [items];

    let tempItems = [];
    let itemsArray = itemArr.map((item, index) => {
      return ({
        name: (
          <ListTableImageColumn
            name={item.name}
            sku={item.sku}
            key={index}
            images={item.images}
            showModalUponClick={!this.props.inModal}
            id={item.pivot.item_id}
            association={item.association}
          />
        ),
        raw_qty: `${item.pivot.quantity}`,
        // unit: `${item.unit}`,
        // purchase_price: `${currency.symbol || '$'}${item.purchase_unit_price}`,
      });
    });
    return [...itemsArray, ...tempItems];
  }

  renderSidebar() {
    //console.log(this.state.itemGroup, "itemGroupItems>>>>>>");
    const preparedData =
      typeof this.state.itemGroup !== 'undefined'
        ? this.prepareItemsData(this.state.items, this.state.currency)
        : [];
    // const tableHeaders = [
    //   'Item',
    //   'Cost Price',
    //   'Selling Price',
    //   'Stock On Hand',
    //   'Reorder Level',
    // ];
    const rawKeys = [
      'name',
      // 'cost_price',
      // 'selling_price',
      'raw_qty',
      // 'reorder_level',
    ];
    const tableHeaders = rawKeys.map((key) =>
      t(`Items.opening_stock_distribution_options.${key}`)
    );
    const tableData = [
      'name',
      // 'purchase_price',
      // 'selling_price',
      'raw_qty',
      // 're_order_level',
    ];
    return (
      <Box
        className={`item-groups-tab item-groups-table float-left w-100 ${this.props?.match?.params?.id ? 'single-item_table-set' : ''
          }`}
      >
        <div className="height_custom_item_group scrollbar_style ps-25">
          <Table
            list={preparedData}
            tableHeaders={tableHeaders}
            tableData={tableData}
            className="details-table group_items_table"
            rowColor
          />
          <p className="__notItemsFound">
            {preparedData.length === 0 ? t('Items.no_items_found') : null}
          </p>
        </div>
      </Box>
    );
  }

  prepareItemsOpenStockData(items, currency) {
    return items.map((item) => ({
      id: `${item.id}`,
      name: `${item.name}`,
      sku: `${item.sku}`,
      inventory_type: item.inventory_type,
      stock: item.stocks.map((stock) => ({
        warehouse_name: `${stock.warehouse.name}`,
        warehouse_primary: `${stock.warehouse.is_primary}`,
        warehouse_active: `${stock.warehouse.is_active}`,
        open_quantity: `${stock.opening_quantity}`,
        open_stock_value: `${currency.symbol}${parseFloat(
          stock.opening_quantity * item.purchase_unit_price
        ).toFixed(2)}`,
      })),
    }));
  }

  renderOpenStockData() {
    if (this.state.itemGroup.items !== undefined) {
      const preparedOpenStockData = this.prepareItemsOpenStockData(
        this.state.itemGroup.items,
        this.state.currency
      );
      return (
        <div className="float-left w-100">
          <OpenStockTable list={preparedOpenStockData} />
        </div>
      );
    }
  }

  closeAllModals = () => {
    this.setState({
      showOpeningStock: false,
      showAdjustquantityModal: false
    });
  };

  handleOpeningStockModal() {
    this.setState({ showOpeningStock: true });
  }
  handleadjustQuantityModal = () => {
    this.setState({ showAdjustquantityModal: true });
  }
  renderAdjustquantityModal() {
    const { itemGroup } = this.state;
    // console.log('itemGroup', itemGroup);
    const { name, sku, unit, physical_stock, accounting_stock, opening_stock, images } = itemGroup;

    return (
      <CustomModal
        fill="#000000"
        Icon={AddRetrunReceive}
        showModal={this.state.showAdjustquantityModal}
        title="Adjust Quantity"
        renderActions={true}
        onClose={this.closeAllModals}
        classNames="new-recieve-payment-popup"
        onSubmit={() => {
          const newStock = this.state.adjustedStock;
          if (!newStock && newStock !== 0) {
            this.props.handleToast('Please enter a valid stock value', 'error');
            return;
          }

          const payload = {
            raw_items: [
              {
                raw_item_id: this.id,
                opening_stock: newStock,
              },]
          }

          restRequest('put', `rawitems/stock/update`, {
            raw_items: payload.raw_items,
          })
            .then((res) => {
              this.props.handleToast(res.message || 'Stock adjusted successfully', 'success');
              this.setState({ showAdjustquantityModal: false, adjustedStock: '' });
              this.fetchData();
            })
            .catch((err) => {
              this.props.handleToast(err.message || 'Something went wrong', 'error');
            });
        }}
      >
        <table className="list-table form-focus form-table border adjustment-form-table add_adjustment">
          <thead>
            <tr>
              <th>{t('Items.item_name')}</th>
              <th className="right-align">{t('Items.available_stock')}</th>
              <th className="right-align">{t('Items.updated_stock')}</th>
              <th className="right-align">{t('Items.adjusted_stock')}</th>
            </tr>
          </thead>
          <tbody>
            <tr className="table--row adjust-width">

              <td>
                <ListTableImageColumn
                  name={name}
                  sku={sku}
                  images={images || []}
                />
              </td>

              <td className="right-align">
                <Quantity
                  quantity={physical_stock}
                  unit={unit}
                />
              </td>

              <td className="right-align">
                <Quantity
                  quantity={physical_stock + (this.state.adjustedStock || 0)}
                  unit={unit}
                />
              </td>

              <td className="right-align no-padding with-close--btn">
                <div className="adjustment-qty">
                  <MdRemove
                    className="material-icon adjustment-icon-gray"
                    onClick={() =>
                      this.setState((prev) => ({
                        adjustedStock: (prev.adjustedStock || 0) - 1,
                      }))
                    }
                  />
                  <Field
                    size="xs"
                    type="number"
                    value={this.state.adjustedStock} className="adjustment-field"
                    decimalScale={2}
                    thousandSeparator=","
                    placeholder={t('common.eg_5_or_minus_5')}
                    allowNegative
                    itemsAdjustment={true}
                    onValueChange={(value) =>
                      this.setState({ adjustedStock: value.floatValue || null })
                    }
                    error={
                      (this.state.adjustedStock ?? physical_stock) === 0 && 'Cannot be 0'
                    }
                    isAllowed={({ floatValue }) => {
                      if (!floatValue) return true;
                      return floatValue <= 9999999999;
                    }}
                  />
                  <MdAdd
                    className="material-icon adjustment-icon-green"
                    onClick={() =>
                      this.setState((prev) => ({
                        adjustedStock: (prev.adjustedStock || 0) + 1,
                      }))
                    }
                  />
                </div>
              </td>

            </tr>
          </tbody>
        </table>
        {/* Item Detail Section */}
        {/* <div className="section-details--info" style={{ marginBottom: '16px' }}>
          <div className="field-row">
            <div className="section-details--info-title semi-bold heading_font">Item Name</div>
            <div className="semi-bold">{name || '---'}</div>
          </div>
          <hr className="bottom_line" />

          {/* <div className="field-row">
            <div className="section-details--info-title semi-bold heading_font">SKU</div>
            <div className="semi-bold">{sku || '---'}</div>
          </div> */}
        {/* <hr className="bottom_line" />

        <div className="field-row">
          <div className="section-details--info-title semi-bold heading_font">Unit</div>
          <div className="semi-bold">{unit || '---'}</div>
        </div>
        <hr className="bottom_line" />

        <div className="field-row">
          <div className="section-details--info-title semi-bold heading_font">Current Physical Stock</div>
          <div className="semi-bold">{physical_stock ?? '---'}</div>
        </div>
        <hr className="bottom_line" />
        <div className="field-row">
          <div className="section-details--info-title semi-bold heading_font">Current Accounting Stock</div>
          <div className="semi-bold">{accounting_stock ?? '---'}</div>
        </div>
        <hr className="bottom_line" />

        <div className="field-row">
          <div className="section-details--info-title semi-bold heading_font">Current Opening Stock</div>
          <div className="semi-bold">{opening_stock ?? '---'}</div>
        </div>
        <hr className="bottom_line" />
 */}
        {/* Adjust Opening Stock Field */}
        {/* <div className="field-row" style={{ marginTop: '12px' }}>
          <label
            className="section-details--info-title semi-bold heading_font"
            htmlFor="adjust-stock-input"
            style={{ display: 'block', marginBottom: '6px' }}
          >
            Adjust Stock <span style={{ color: 'red' }}>*</span>
          </label>
          <input
            id="adjust-stock-input"
            type="number"
            min="0"
            className="form-control"
            placeholder="Increase or decrease stock"
            value={this.state.adjustedStock || ''}
            onChange={(e) =>
              this.setState({ adjustedStock: parseFloat(e.target.value) })
            }
            style={{ width: '80%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
        </div> */}
      </CustomModal>
    );
  }
  renderOpeningStock() {
    return (
      <CustomModal
        showModal={this.state.showOpeningStock}
        title={this.props.t('Items.opening_stock_distribution')}
        Icon={AddRetrunReceive}
        fill="#000000"
        size="large"
        className="stock_distribution_popup"
        renderActions={false}
        onClose={this.closeAllModals}
        classNames="opening-stock-popup"
      >
        {this.renderOpenStockData()}
      </CustomModal>
    );
  }

  // <-------- ConfirmationDialog Handlers
  closeConfirmationModalHandler = () => {
    this.setState({ showConfirmationModal: false });
  };
  btnClicksHandler = ({ id = null, type = '', ...rest }) => {
    this.setState({ confirmationModalBtnLoader: true });
    let payload;
    const {
      store_id = null,
      mappedItemData = {},
      stockSelect = '',
      stockSelectValue = '',
      market_place_item_id = null,
      sync_item_name = '',
      storeType = '',
    } = rest;

    let url =
      storeType === 'shopify'
        ? 'shopify/items/associate_items'
        : 'woocom/items/associate_items';

    if (type === 'confirm') {
      payload = {
        store_id: store_id,
        items: [
          {
            inventory_type: 'inventory',
            item_id: 0,
            market_place_item_id: market_place_item_id,
            // rowIndex: 0,
            stock: stockSelectValue,
            stock_status: stockSelect,
            sync_item_id: id,
            sync_item_name: sync_item_name,
          },
        ],
      };
    } else if (type === 'exist') {
      payload = {
        store_id: store_id,
        items: [
          {
            inventory_type: mappedItemData.inventory_type,
            item_id: mappedItemData.id,
            market_place_item_id: market_place_item_id,
            // rowIndex: 0,
            stock: stockSelectValue,
            stock_status: stockSelect,
            sync_item_id: id,
            sync_item_name: sync_item_name,
          },
        ],
      };
    }
    restRequest('post', url, payload)
      .then((res) => {
        this.setState({ showConfirmationModal: false });
        this.props.handleToast(res.message, 'success');
        this.fetchData();
        this.setState({ confirmationModalBtnLoader: false });
      })
      .catch((error) => {
        this.setState({ confirmationModalBtnLoader: false });
        this.props.handleToast(error.message, 'error');
      });
  };
  // ConfirmationDialog Handlers ----->

  render() {
    const hasViewPermission = true;

    if (this.state.loading) return <Loader />;
    if (this.state.notFound) return <NotFound />;
    var secondaryButtonLabel = this.props.t('Items.opening_stock_distribution');
    return (
      <Fragment>
        {this.renderAdjustquantityModal()}
        <TempItemMappedModal
          itemData={this.state.confirmationModalDataItem}
          showModal={this.state.showConfirmationModal}
          closeModal={this.closeConfirmationModalHandler}
          confirmBtnClicks={this.btnClicksHandler}
          itemsList={this.state.confirmationModalWoocomList}
          loading={this.state.confirmationModalLoading}
          btnLoader={this.state.confirmationModalBtnLoader}
        />
        {!hasViewPermission && <AccessDenied type="section" />}

        {hasViewPermission && (
          <div className="raw_items_setailse float-left w-100 position-relative  sales_order_set  raw-item-details-page">
            {!this.props.inModal && (
              <div className="close_icon">
                <MdClose
                  onClick={() => {
                    let dataFromLS = getObjFromLS('module');
                    setObjInLS('module', {
                      ...dataFromLS,
                      presistDetailPage: false,
                    });
                    setValueInLS('fullscreen', 'true');
                    sessionStorage.setItem('once', true);
                    this.props.history.push('/r');
                  }}
                />
              </div>
            )}
            <div
              className={`float-left w-80 border-right-set ${this.props?.match?.params?.id ? 'item-group-single' : ''
                }`}
            >
              <Menu
                menus={this.menus()}
                currentMenu={this.state.currentMenu}
                history={this.props.history}
                inModal={this.props.inModal || false}
              />
              {this.renderLayoutView()}

              {this.state.viewAssociationTable && this.renderSidebar()}
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}

export default withTranslation()(
  HeaderWrapper(RawItemDetails, {
    name: 'Items.raw_items',
    tableIcon: 'general_module_icon icon_top',
    deleteName: 'Raw Item',
    deleteText: 'rawitems',
    Icon: NewItemIcon,
    baseUrl: 'rawitems',
    redirectUrl: '/raw-items',
    showAddTrue: true,
    showName: true,
    onlyMenu: true,
    permissionName: 'itemGroups',
  }
  )
);
